import React, { useState, useContext } from 'react'
import { UserContext } from '../../../contexts/userProvider'
import { BiUser, BiArrowBack, BiMailSend } from 'react-icons/bi'
import { Link } from 'react-router-dom'


const Esqueci = () => {
    const { esqueciSenha, setAlert } = useContext(UserContext);
    const [login, setLogin] = useState({ email: '' })

    function handleEmailChange(event) {
        setLogin({ ...login, email: event.target.value })
    }

    function logIn() {
        if(login.email === '') {
            setAlert({visible: true, title: 'Atenção!', placeholder: 'Para enviar o e-mail de recuperação, preencha o campo!', confirm: false, type: 'warning'})
        } else {
            esqueciSenha(login.email)
        }
    }


    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Header */}
                <div className="text-center mb-10">
                    <div className="flex items-center justify-center mb-8">
                        <Link 
                            to="/login" 
                            className="p-3 bg-white hover:bg-gray-50 rounded-xl transition-colors duration-200 mr-4 shadow-lg border border-gray-100"
                        >
                            <BiArrowBack className="h-6 w-6 text-gray-600" />
                        </Link>
                        <h1 className="text-3xl font-bold text-gray-900">
                            Recuperar Senha
                        </h1>
                    </div>
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                        <BiMailSend  className="h-8 w-8 text-white" />
                    </div>
                    <p className="text-gray-600 text-lg">
                        Digite seu e-mail para receber as instruções de recuperação
                    </p>
                </div>

                {/* Formulário */}
                <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-8">
                    <form className="space-y-6" onSubmit={(e) => { e.preventDefault(); logIn(); }}>
                        {/* Campo de e-mail */}
                        <div className="space-y-2">
                            <label className="text-sm font-medium text-gray-700">E-mail</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                    <BiUser className="h-5 w-5 text-gray-400" />
                                </div>
                                <input 
                                    className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl bg-gray-50 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                                    type="email" 
                                    placeholder="Digite seu e-mail" 
                                    value={login.email}
                                    onChange={handleEmailChange}
                                    required
                                />
                            </div>
                        </div>

                        {/* Botão de enviar */}
                        <button 
                            type="submit"
                            className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                            <span className="flex items-center justify-center">
                                Enviar Instruções
                                <BiMailSend  className="ml-2 h-5 w-5" />
                            </span>
                        </button>

                        {/* Link de volta */}
                        <div className="text-center pt-4">
                            <Link 
                                to="/login" 
                                className="text-sm text-indigo-600 hover:text-indigo-700 font-medium transition-colors duration-200 hover:underline"
                            >
                                Voltar para o login
                            </Link>
                        </div>
                    </form>
                </div>

                {/* Informação adicional */}
                <div className="mt-6 p-4 bg-blue-50 rounded-xl border border-blue-100">
                    <p className="text-sm text-blue-700 text-center">
                        <strong>Dica:</strong> Verifique sua caixa de spam se não receber o e-mail em alguns minutos.
                    </p>
                </div>

                {/* Footer */}
                <div className="mt-8 text-center">
                    <p className="text-xs text-gray-500">
                        © 2024 VoxCity Tecnologia - Sistema ERP Empresarial
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Esqueci
